
import { defineComponent } from 'vue'

import Tabs from '@/common/components/UI/Tabs/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { TabT } from '@/core/types/components.types'

export default defineComponent({
    components: {
        tabs: Tabs,
        TheButton,
    },
    setup() {
        const tabs: TabT[] = [
            { id: 1, name: 'Создание поступления', path: '/admission/create' },
            { id: 2, name: 'Поступление вторичного материала', path: '/admission/secondary' },
        ]

        return { tabs }
    },
})
